function safeGet(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // ignore
  }
}

function normalizeUserKey(user) {
  if (!user || typeof user !== "object") return "";
  const id = user?.id ?? user?.user_id ?? user?.uid ?? null;
  if (id !== null && id !== undefined && String(id).trim()) return `id:${String(id).trim()}`;
  const email = typeof user?.email === "string" ? user.email.trim().toLowerCase() : "";
  if (email) return `email:${email}`;
  return "";
}

export function getTrialConsumedStorageKey(user) {
  const uk = normalizeUserKey(user);
  if (!uk) return "";
  return `femtyz_trial_consumed:${uk}`;
}

export function hasConsumedTrial(user) {
  const key = getTrialConsumedStorageKey(user);
  if (!key) return false;
  return safeGet(key) === "1";
}

export function markTrialConsumed(user) {
  const key = getTrialConsumedStorageKey(user);
  if (!key) return;
  safeSet(key, "1");
}

